const updatePanField = (config) =>{
    console.log('rec',config)
    
    config.requestBody.formFields.fields.map(
        (item)=>{
            if(item.name === "primaryDetails"){
                console.log('prima item',item)
                item.obj.map((primItem)=>{
                    if(primItem.name === "LifeAssured"){
                        console.log('LifeAssured item',primItem)
                        primItem.obj.map((lifeItem)=>{
                            if(lifeItem.name === "PAN"){
                                console.log('PAN item',lifeItem)
                                lifeItem.required=true

                            }
                        })
                    }
                })
            }
        }
    )

    console.log('finaal',config)
}

export default updatePanField